import { 
  MdHowToVote, MdStar, MdEmojiEvents, MdWorkspacePremium,
  MdLocalFireDepartment, MdAutoAwesome, MdCreate, MdVerified, MdTrendingUp
} from 'react-icons/md';
import { FaCrown, FaTrophy, FaMedal, FaFire } from 'react-icons/fa6';

export const iconMap = {
  'vote': MdHowToVote,
  'star': MdStar,
  'award': MdWorkspacePremium,
  'trophy': FaTrophy,
  'crown': FaCrown,
  'create': MdCreate,
  'sparkle': MdAutoAwesome,
  'fire': MdLocalFireDepartment,
  'flame': FaFire,
  'medal': FaMedal,
  'expert': MdVerified,
  'rising': MdTrendingUp,
  'default': MdEmojiEvents
};

export const badgeHowToEarn = {
  'first_vote': 'Cast your very first vote on any poll to earn this badge.',
  'engaged_voter': 'Answer 10 or more polls to show your civic engagement.',
  'active_citizen': 'Vote on 25 polls to become an active citizen.',
  'dedicated_voter': 'Answer 50 polls to demonstrate your dedication to democracy.',
  'century_voter': 'Answer 100 polls and join the Century Club.',
  'super_voter': 'Vote on 250 polls to become a super voter.',
  'elite_voter': 'Vote on 500 polls to reach elite status.',
  'legendary_voter': 'Vote on 1000 polls and become a legend.',
  'poll_creator': 'Create your first custom poll to earn this badge.',
  'prolific_creator': 'Create 5 or more custom polls to share your ideas.',
  'poll_master': 'Create 10 polls to become a poll master.',
  'content_king': 'Create 25 polls and reign as content king.',
  'poll_mogul': 'Create 50 polls to become a poll mogul.',
  'streak_starter': 'Vote on consecutive days to build a 3-day voting streak.',
  'weekly_warrior': 'Maintain a 7-day voting streak without missing a day.',
  'fortnight_fighter': 'Keep voting for 14 consecutive days.',
  'monthly_master': 'Achieve an impressive 30-day voting streak.',
  'streak_legend': 'Maintain a 60-day voting streak.',
  'unstoppable': 'Reach an incredible 100-day voting streak.',
  'point_collector': 'Earn 50 poll points by answering polls.',
  'point_hoarder': 'Accumulate 100 poll points.',
  'point_master': 'Reach 250 poll points.',
  'point_legend': 'Earn 500 poll points.',
  'point_titan': 'Achieve 1000 poll points.',
  'topic_explorer': 'Vote in 3 different topic categories.',
  'topic_enthusiast': 'Vote in 5 different topic categories.',
  'topic_master': 'Vote in 10 different topic categories.',
  'well_rounded': 'Vote in all available topic categories.',
  'rising_star': 'Reach 100 contribution score.',
  'top_contributor': 'Reach 500 contribution score.',
  'civic_champion': 'Reach 1000 contribution score.',
  'civic_hero': 'Reach 2500 contribution score.',
  'civic_legend': 'Reach 5000 contribution score.',
  'early_bird': 'Cast a vote before 8 AM.',
  'night_owl': 'Cast a vote after midnight.',
  'weekend_warrior': 'Vote on weekends 5 times.',
  'quick_draw': 'Vote within 1 hour of poll creation.',
  'opinion_leader': 'Have your poll receive 50+ votes.',
  'viral_creator': 'Have your poll receive 100+ votes.',
  'first_share': 'Share your first poll on social media.',
  'social_butterfly': 'Share 10 polls on social media.',
  'influencer': 'Share 25 polls and become an influencer.',
  'topic_expert': 'Vote on 10+ polls in a single category.',
  'top_10_percent': 'Be in the top 10% of all voters.',
  'default': 'Keep participating in polls to unlock this achievement!'
};

export function BadgeIcon({ icon, color, size = 24, earned = true }) {
  const IconComponent = iconMap[icon] || iconMap['default'];
  return (
    <IconComponent 
      size={size} 
      style={{ color: earned ? color : '#9CA3AF' }}
    />
  );
}
